@if (todoID) {
  <div class="text-center mb-1">
    <mat-button-toggle-group appearance="legacy" name="fontStyle" aria-label="Font Style" [(value)]="currentPage">
      @if (data.contentID) {
        <mat-button-toggle value="content">{{ 'Global.Content' | translate }}</mat-button-toggle>
      }
      <mat-button-toggle value="todoDetails">{{ 'Global.Details' | translate }}</mat-button-toggle>
      <mat-button-toggle value="members">{{ 'Global.Members' | translate }}</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
}

@if (todoID && currentPage == 'content' && (contentID || contentID != 'null')) {
  <div style="display: flex; justify-content: space-between">
    <div id="dummy"></div>
    <button mat-icon-button mat-dialog-close (click)="goToThePage()">
      <mat-icon>open_in_new</mat-icon>
    </button>
  </div>
}

<mat-dialog-content class="mat-typography" (scroll)="onScroll($event)">
  @if (currentPage == 'content') {
    <app-content [readMode]="'true'" [contentID]="contentID" [dialogData]="data.content" [from]="'pop-content'"></app-content>
  }
  @if (currentPage == 'todoDetails' || currentPage == 'members') {
    <app-create-event [currentView]="currentPage" [inputData]="data" [hideSaveButton]="'true'" #createEventModal></app-create-event>
  }
</mat-dialog-content>

@if (todoID && event.isAdmin) {
  <mat-dialog-actions class="bottom-card-flex">
    <button mat-flat-button color="accent" (click)="deleteTodo()">
      {{ 'Global.Delete' | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="save()">
      {{ 'Global.Save' | translate }}
    </button>
  </mat-dialog-actions>
}
